"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const getState_1 = require("../helpers/getState");
// @ts-ignore: maintain function signature
function evaluateScormCard(command, user, content, states) {
    const updatedStates = immer_1.produce(states, draftStates => {
        const state = getState_1.getStateByContentIdUserId(draftStates, content._id, user.userId);
        if (state.completionStatus === 'complete') {
            state.scaledProgressMeasure = 1.0;
        }
    });
    return { states: updatedStates, events: [], stateInteractions: [] };
}
exports.evaluateScormCard = evaluateScormCard;
//# sourceMappingURL=evaluateScormCard.js.map